// extracted by mini-css-extract-plugin
export default {"containerV2":"FailedMessageFooter__containerV2___BE67Z","textContainer":"FailedMessageFooter__textContainer___bk7Hp","text":"FailedMessageFooter__text___WVEZ3"};